import { QueryClient } from "react-query";

function queryErrorHandler(error: any): void {
  const title =
    error instanceof Error ? error.message : "error connecting to server";
  // toast.error(title);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //onError: queryErrorHandler,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      //onError: queryErrorHandler,
    },
  },
});

const optimisticOptions = (query: string) => {
  return {
    onMutate: async (newChange: any) => {
      await queryClient.cancelQueries([query, newChange.id]);

      const previousData = await queryClient.getQueryData([query, newChange.id]);

      await queryClient.setQueryData([query, newChange.id], newChange);

      return { previousData, newChange };
    },
    onError: async (err: any, newChange: any, context: any) => {
      await queryClient.setQueryData([query, context.newChange.id], context.previousData);
    },
    onSettled: async (newChange: any) => {
      // First invalidate any query with this base key
      await queryClient.invalidateQueries([query]);
      
      // Extract uin_id from endpoint when working with configs/activities
      if (query === 'activities' && newChange && newChange.endPoint) {
        const match = newChange.endPoint.match(/\/config\/activity-status\/([^/]+)/);
        if (match && match[1]) {
          const uin_id = match[1];
          // Specifically invalidate the activities query with this uin_id
          await queryClient.invalidateQueries([query, uin_id]);
        }
      }
    },
  };
};

export { queryClient, optimisticOptions };
